export const proceedId = 'proceed';

export const emailFreeErrorMessage = 'Please use corporate email';
